import { ROLES } from '@/constants/roles';

export const moderatorEventsModerate = {
  path: '/moderator-events-moderate',
  name: 'moderator-events-moderate',
  component: () => import('./views/moderator-events-moderate.vue'),
  meta: {
    title: 'Модерация мероприятий',
    layout: 'ui-design',
    roles: [ROLES.moderator],
  },
};

export const moderatorsList = {
  path: '/moderators',
  name: 'moderators',
  component: () => import('./views/moderators-list.vue'),
  meta: {
    title: 'Модераторы',
    accessList: [ROLES.operator, ROLES.department],
  },
};

export const uiModeratorsList = {
  path: '/ui-moderators',
  name: 'ui-moderators',
  component: () => import('./views/moderators-list.vue'),
  meta: {
    title: 'Модераторы',
    layout: 'ui-design',
    accessList: [ROLES.operator, ROLES.department],
  },
  props: {
    hideTitle: true,
  },
};

export default [moderatorEventsModerate, moderatorsList, uiModeratorsList];
